
import { MailSettings } from "@/models/mail-settings";
import { MailSettingsService } from "@/services/mail-settings-service";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { ISelectItem } from "winfakt-vue-components";
export default Vue.extend({
	data(){
		return {
			settings: [] as MailSettings[]
		};
	},
	props: {
		fancy: Boolean,
		label: {
			type: [Object as ()=>TranslateResult, String]
		},
		value: {
			type: [Number, Object as ()=>MailSettings]
		},
		addEmptyValue: Boolean,
		emptyText: [Object as ()=>TranslateResult, String],
		useIds: Boolean
	},
	computed: {
		selectedValue():MailSettings | null{
			if (!this.value) return null;
			if (typeof(this.value) == "object") {
				var id = this.value.ID;
			}else{
				var id = this.value;
			}
			return this.settings.find(s=>s.ID == id) || null;
		},
		nullValueText():TranslateResult | string {
			if (this.emptyText) {
				return this.emptyText;
			}
			return this.$ct("common.none");
		},
		items():ISelectItem<MailSettings | null>[]{
			let allSettings:ISelectItem<MailSettings | null>[] = this.settings.map(s=>{
				return {
					text: s.Label,
					value: s
				} as ISelectItem<MailSettings>;
			});
			if (this.addEmptyValue){
				allSettings.unshift({
					text: this.nullValueText,
					value: null
				});
			}
			return allSettings;
		}
	},
	methods: {
		setValue(val:MailSettings | null){
			if (this.useIds){
				if (!val){
					return this.$emit("input", 0);
				}
				return this.$emit("input", val.ID);
			}
			if (!val){
				return this.$emit("input", null);
			}
			this.$emit("input", val);
		}
	},
	async mounted(){
		this.settings = await MailSettingsService.getSettings();
	}
});
